import { motion } from "framer-motion";
import { Smartphone, Download, Star, Apple, Play } from "lucide-react";

const appImages = [
  {
    url: "https://images.unsplash.com/photo-1502201563651-826cbb30c3dd?w=800&q=80",
    label: "APP DEVELOPMENT",
  },
  {
    url: "https://images.unsplash.com/photo-1565263965454-a44e2ede252a?w=800&q=80",
    label: "iOS DESIGN",
  },
  {
    url: "https://images.unsplash.com/photo-1531986362435-16b427eb9c26?w=800&q=80",
    label: "MOBILE UX",
  },
  {
    url: "https://images.unsplash.com/photo-1745151283509-a75502fc5a73?w=800&q=80",
    label: "USER TESTING",
  },
  {
    url: "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=800",
    label: "ANDROID STUDIO",
  },
  {
    url: "https://images.pexels.com/photos/1779487/pexels-photo-1779487.jpeg?auto=compress&cs=tinysrgb&w=800",
    label: "PUBLISHING",
  },
];

const features = [
  "Progettazione UI/UX",
  "Sviluppo iOS & Android",
  "Pubblicazione App Store",
  "Pubblicazione Google Play",
  "Aggiornamenti e Manutenzione",
  "Analytics & Performance",
];

function CarouselStrip({ images, speed = 35, direction = "left" }) {
  const doubled = [...images, ...images];
  return (
    <div className="overflow-hidden">
      <div
        className={direction === "left" ? "animate-carousel-left" : "animate-carousel-right"}
        style={{ animationDuration: `${speed}s` }}
      >
        <div className="flex gap-4" style={{ width: "max-content" }}>
          {doubled.map((img, i) => (
            <div key={i} className="group relative w-[300px] sm:w-[360px] h-[200px] sm:h-[230px] flex-shrink-0 overflow-hidden border border-white/10">
              <img src={img.url} alt={img.label} className="w-full h-full object-cover transition-all duration-700 grayscale-[50%] group-hover:grayscale-0 group-hover:scale-105" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/90 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <span className="font-mono text-[10px] tracking-[0.25em] text-white/90">{img.label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function AppDevSection() {
  return (
    <section data-testid="app-dev-section" id="app-dev" className="py-24 sm:py-32 bg-[#050505] overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 sm:px-12 mb-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <span className="font-mono text-xs tracking-[0.2em] text-[#FF3366] uppercase">SVILUPPO APP</span>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mt-4 leading-tight">
            Sviluppo App &<br />
            <span className="text-[#A3A3A3]">Divulgazione Multi-Portale</span>
          </h2>
          <p className="text-[#A3A3A3] font-body text-lg mt-6 max-w-2xl">
            Progettiamo, sviluppiamo e pubblichiamo le tue applicazioni su iOS App Store e Google Play Store, garantendo massima visibilita e distribuzione su tutti i portali.
          </p>
        </motion.div>
      </div>

      <CarouselStrip images={appImages} speed={38} direction="left" />

      <div className="max-w-[1440px] mx-auto px-6 sm:px-12 mt-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"
        >
          {features.map((f, i) => (
            <div key={i} data-testid={`app-feature-${i}`} className="flex items-center gap-3 border border-white/10 bg-[#121212] p-4 hover:border-[#FF3366]/40 transition-colors">
              {i < 2 ? <Smartphone size={18} className="text-[#FF3366] flex-shrink-0" /> :
               i === 2 ? <Apple size={18} className="text-[#FF3366] flex-shrink-0" /> :
               i === 3 ? <Play size={18} className="text-[#FF3366] flex-shrink-0" /> :
               i === 4 ? <Download size={18} className="text-[#FF3366] flex-shrink-0" /> :
               <Star size={18} className="text-[#FF3366] flex-shrink-0" />}
              <span className="text-white/80 text-sm font-body">{f}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
